import { render } from "./ClubDealSellChat.vue?vue&type=template&id=059eb000&scoped=true&ts=true"
import script from "./ClubDealSellChat.vue?vue&type=script&lang=ts"
export * from "./ClubDealSellChat.vue?vue&type=script&lang=ts"

import "./ClubDealSellChat.vue?vue&type=style&index=0&id=059eb000&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059eb000"]])

export default __exports__